export default __webpack_public_path__ + "static/media/PowellCatLocation-10.e59f0397.jpg";